import React from 'react';
import { Layout } from '../components/layout/Layout';
import { Card, CardContent } from '../components/ui/card';
import { Shield, Mail, Database, Clock, Users, Lock, Globe, FileText, AlertCircle } from 'lucide-react';

export default function PrivacyPage() {
  return (
    <Layout>
      <div className="container-app py-8 md:py-12 max-w-3xl">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary/10 mb-4">
            <Shield className="w-8 h-8 text-primary" />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold mb-2">Politique de Confidentialité</h1>
          <p className="text-muted-foreground">Oknî - Banque du Temps</p>
          <p className="text-sm text-muted-foreground mt-2">Dernière mise à jour : 14 février 2026</p>
        </div>

        <div className="space-y-8">
          {/* Section 1 */}
          <Card className="rounded-2xl">
            <CardContent className="p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Users className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3">1. Responsable du traitement</h2>
                  <ul className="space-y-2 text-muted-foreground">
                    <li><strong>Structure :</strong> Oknî</li>
                    <li><strong>Adresse :</strong> Brabant wallon, Belgique (adresse complète communiquée prochainement)</li>
                    <li><strong>Email RGPD :</strong> <a href="/contact" className="text-primary underline" data-testid="legal-contact-link">formulaire de contact</a></li>
                  </ul>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Section 2 */}
          <Card className="rounded-2xl">
            <CardContent className="p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Database className="w-5 h-5 text-primary" />
                </div>
                <div className="flex-1">
                  <h2 className="text-xl font-semibold mb-3">2. Données personnelles collectées</h2>
                  
                  <h3 className="font-medium mt-4 mb-2">2.1 A l&apos;inscription</h3>
                  <ul className="list-disc list-inside text-muted-foreground space-y-1 ml-2">
                    <li>Nom complet</li>
                    <li>Adresse email</li>
                    <li>Mot de passe (hache bcrypt)</li>
                    <li>Localisation</li>
                  </ul>

                  <h3 className="font-medium mt-4 mb-2">2.2 A l&apos;utilisation</h3>
                  <ul className="list-disc list-inside text-muted-foreground space-y-1 ml-2">
                    <li>Téléphone (optionnel)</li>
                    <li>Avatar (optionnel)</li>
                    <li>Bio (optionnelle)</li>
                    <li>Contenu des annonces</li>
                    <li>Messages échanges</li>
                    <li>Avis laisses</li>
                  </ul>

                  <h3 className="font-medium mt-4 mb-2">2.3 Automatiquement</h3>
                  <ul className="list-disc list-inside text-muted-foreground space-y-1 ml-2">
                    <li>Historique des transactions crédits-temps</li>
                    <li>Données de connexion (JWT, horodatages)</li>
                    <li>Données Google OAuth (si utilisé)</li>
                  </ul>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Section 3 */}
          <Card className="rounded-2xl">
            <CardContent className="p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <FileText className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3">3. Finalites du traitement</h2>
                  <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-2">
                    <li>Creation et gestion du compte utilisateur</li>
                    <li>Fonctionnement de la banque du temps (matching, échanges, credits)</li>
                    <li>Communication entre utilisateurs (messagerie)</li>
                    <li>Notifications liees à l&apos;activité</li>
                    <li>Moderation et gestion des signalements</li>
                    <li>Amelioration de la plateforme (statistiques agregees)</li>
                  </ul>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Section 4 */}
          <Card className="rounded-2xl">
            <CardContent className="p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Shield className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3">4. Base legale</h2>
                  <ul className="space-y-3 text-muted-foreground">
                    <li>
                      <strong>Consentement (art. 6.1.a RGPD) :</strong> inscription volontaire à la plateforme
                    </li>
                    <li>
                      <strong>Execution du contrat (art. 6.1.b) :</strong> fourniture des services de la banque du temps
                    </li>
                    <li>
                      <strong>Interet légitime (art. 6.1.f) :</strong> sécurité de la plateforme et prevention des abus
                    </li>
                  </ul>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Section 5 */}
          <Card className="rounded-2xl">
            <CardContent className="p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Clock className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3">5. Durée de conservation</h2>
                  <ul className="space-y-2 text-muted-foreground">
                    <li><strong>Données de compte :</strong> tant que le compte est actif + 30 jours après suppression</li>
                    <li><strong>Messages :</strong> durée de vie du compte</li>
                    <li><strong>Historique des transactions :</strong> 5 ans après la dernière transaction</li>
                    <li><strong>Signalements :</strong> 1 an après resolution</li>
                  </ul>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Section 6 */}
          <Card className="rounded-2xl">
            <CardContent className="p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Users className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3">6. Destinataires des données</h2>
                  <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-2">
                    <li><strong>Autres utilisateurs :</strong> profil public (nom, localisation, bio, annonces, avis)</li>
                    <li><strong>Administrateurs :</strong> moderation et support</li>
                    <li><strong>Sous-traitants techniques :</strong> Emergent.sh (hébergement), Google (OAuth)</li>
                  </ul>
                  <p className="mt-3 text-sm text-primary font-medium">
                    Aucune vente ni partage de données à des fins commerciales.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Section 7 */}
          <Card className="rounded-2xl">
            <CardContent className="p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Globe className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3">7. Transfert hors UE</h2>
                  <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-2">
                    <li>Google OAuth peut impliquer un transfert vers les USA (clauses contractuelles types)</li>
                    <li>Hébergement Emergent.sh : a vérifier selon localisation des serveurs</li>
                  </ul>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Section 8 */}
          <Card className="rounded-2xl">
            <CardContent className="p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Shield className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3">8. Vos droits (RGPD)</h2>
                  <p className="text-muted-foreground mb-3">
                    Conformement au RGPD, vous disposez des droits suivants :
                  </p>
                  <ul className="list-disc list-inside text-muted-foreground space-y-1 ml-2">
                    <li>Droit d&apos;accès à vos données</li>
                    <li>Droit de rectification</li>
                    <li>Droit à l&apos;effacement (&quot;droit à l&apos;oubli&quot;)</li>
                    <li>Droit à la limitation du traitement</li>
                    <li>Droit à la portabilité (export JSON)</li>
                    <li>Droit d&apos;opposition</li>
                    <li>Droit au retrait du consentement</li>
                  </ul>
                  <p className="mt-3 text-muted-foreground">
                    <strong>Contact :</strong> <a href="/contact" className="text-primary underline" data-testid="legal-contact-link">formulaire de contact</a><br />
                    <strong>Délai de réponse :</strong> 30 jours maximum
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Section 9 */}
          <Card className="rounded-2xl">
            <CardContent className="p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Lock className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3">9. Sécurité des données</h2>
                  <ul className="list-disc list-inside text-muted-foreground space-y-1 ml-2">
                    <li>Chiffrement des mots de passe (bcrypt)</li>
                    <li>Authentification par tokens JWT</li>
                    <li>Connexion sécurisée HTTPS</li>
                    <li>Vérification d&apos;autorisation sur toutes les mutations</li>
                  </ul>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Section 10 */}
          <Card className="rounded-2xl">
            <CardContent className="p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <AlertCircle className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3">10. Reclamation</h2>
                  <p className="text-muted-foreground mb-3">
                    En cas de litige, vous pouvez introduire une reclamation aupres de l&apos;Autorite de protection des données (APD) belge :
                  </p>
                  <div className="p-4 rounded-xl bg-muted/50 text-sm">
                    <p><strong>Autorite de protection des données</strong></p>
                    <p>Rue de la Presse 35, 1000 Bruxelles</p>
                    <p>
                      <a href="https://www.autoriteprotectiondonnees.be" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
                        www.autoriteprotectiondonnees.be
                      </a>
                    </p>
                    <p>
                      <a href="mailto:contact@apd-gba.be" className="text-primary hover:underline">
                        contact@apd-gba.be
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Section 11 */}
          <Card className="rounded-2xl">
            <CardContent className="p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <FileText className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3">11. Modifications</h2>
                  <p className="text-muted-foreground">
                    Cette politique de confidentialité peut être modifiée à tout moment. En cas de modification substantielle, les utilisateurs seront informés via la plateforme. L&apos;utilisation continue du service après notification vaut acceptation des nouvelles conditions.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </Layout>
  );
}
